<script setup lang="ts">
import { customPaths } from "~/utils/constants"

const route = useRoute()
const { locale } = useI18n()

const { data, error } = await usePage(
  `/api/gluon/fetchWikiArticlePage/${locale.value}/${
    route.params.article as string
  }/wiki_article.js`
)

if (error.value) {
  throw createError({
    message: error.value.message,
    statusCode: error.value.statusCode ?? 404
  })
}

// As per TF-2754, when using non-canonical category slug, redirect to the canonical page URL
const mainCategorySlug = data?.value?.page?.category?.slug
if (mainCategorySlug && route.params.category !== mainCategorySlug) {
  if (!!mainCategorySlug) {
    navigateTo(
      `${customPaths.wikiRoot}/${mainCategorySlug}/${route.params.article}`,
      {
        redirectCode: 301
      }
    )
  }
}
</script>

<template>
  <div>
    <SeoBase v-if="data?.seo" v-bind="data.seo" />
    <OrganismsWikiArticle v-if="data?.page" v-bind="data.page" />
  </div>
</template>
